import { NextApiResponseBody } from 'types/bolt-api/request'
import { GetPartnerContactsResponse } from 'lib/partners/types'

export const getPartnerContacts = async (partnerId: string, email: string): Promise<NextApiResponseBody<GetPartnerContactsResponse>> => {
  try {
    if (!partnerId || !email) {
      throw new Error(`${!partnerId ? 'PartnerId' : 'Email'} is missing`)
    }

    const res = await fetch(`/api/partners/${partnerId}/contacts?email=${encodeURIComponent(email)}`, {
      method: 'GET'
    })

    const data: NextApiResponseBody<GetPartnerContactsResponse> = await res.json()

    if (res.ok && data.success) {
      return data
    }

    return {
      success: !!data?.success,
      data: data?.data || { contacts: [] }
    }
  } catch (error) {
    return {
      success: false,
      data: {
        contacts: []
      }
    }
  }
}
